import React, { useState, useEffect } from 'react'
import SearchFlights from './SearchFlights'
import Offers from './Offers'
import PopularFlight from './PopularFlight'
import BottomFaq from './BottomFaq'
import FAQ from './Faq'
import '../landingpage/landing.scss'
import PopularFlightInternational from './PopularFlightInternational'
import AffordableInternationalHolidays from './AffordableInternationalHolidays'
import AffordableDomesticHolidays from './AffordableDomesticHolidays'
import Seo from './../../helmet/Helmet'


const gradients = [
    'linear-gradient(80deg, #a6ffa5, #ccffd5, #eaffeb)',
    'linear-gradient(80deg, #bbffc7, #f1fff7, #bbffc7)',
    'linear-gradient(80deg, #BFC6FF, #f2f2f2, #BFC6FF)',
    'linear-gradient(80deg, #ffe3e3, #fafaff, #ffe2b5)',
    'linear-gradient(80deg, #acddde, #f9fff7, #c0ffe8)'
];

const FlightsHome = () => {

    const [bgGradient, setBgGradient] = useState('');

    useEffect(() => {
        sessionStorage.removeItem("comeFromReview");
        const randomIndex = Math.floor(Math.random() * gradients.length); // Generate a random index
        const randomGradient = gradients[randomIndex]; // Pick a gradient style using the random index
        setBgGradient(randomGradient); // Set the background gradient
    }, []);


    return (

        <div className="App" style={{ background: bgGradient, position: 'relative', zIndex: '0' }}>

            <Seo
                title="Flight Book with Lowest fares + Instant Discount- SuperbWorldTrip"
                description="SuperbWorldTrip offers easy flight booking for domestic & international routes. Get the lowest fares with instant discount & 100% cashback on your first booking"
                link="/flights"
                keywords="Affordable flights, budget air tickets, discount flight tickets, flight booking offers, lowest airfare deals, cheapest flights online, airfare comparison, best flight deals, last-minute flight tickets, international flight bookings, flight booking discounts, airline tickets cheap, book flights online, flight reservation, best prices on flights, find cheap flights, discounted airfares, online flight booking, air ticket deals"
                largeTwitterCard={true}
                addPostfixTitle={false}
                noIndex={true}
            />
            <SearchFlights />
            <Offers />
            <PopularFlight />
            <PopularFlightInternational />
            <AffordableDomesticHolidays />
            <AffordableInternationalHolidays />
            <BottomFaq />
            {/* <FAQ /> */}
        </div>
    )
}

export default FlightsHome